module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    style: (_vm.styleObject),
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('colgroup', _vm._l((_vm.columns), function(column, index) {
    return _c('col', {
      attrs: {
        "width": _vm.setCellWidth(column, index, false)
      }
    })
  })), _vm._v(" "), _c('tbody', {
    class: [_vm.prefixCls + '-tbody']
  }, [_vm._l((_vm.data), function(row, index) {
    return [_c('tr', {
      class: _vm.rowClasses(row._index),
      on: {
        "mouseenter": function($event) {
          $event.stopPropagation();
          _vm.handleMouseIn(row._index)
        },
        "mouseleave": function($event) {
          $event.stopPropagation();
          _vm.handleMouseOut(row._index)
        },
        "click": function($event) {
          $event.stopPropagation();
          _vm.clickCurrentRow(row._index)
        },
        "dblclick": function($event) {
          $event.stopPropagation();
          _vm.dblclickCurrentRow(row._index)
        }
      }
    }, _vm._l((_vm.columns), function(column) {
      return _c('td', {
        class: _vm.alignCls(column, row)
      }, [_c('Cell', {
        key: row,
        attrs: {
          "fixed": _vm.fixed,
          "prefix-cls": _vm.prefixCls,
          "row": row,
          "column": column,
          "natural-index": index,
          "index": row._index,
          "checked": _vm.rowChecked(row._index),
          "disabled": _vm.rowDisabled(row._index),
          "expanded": _vm.rowExpanded(row._index)
        }
      })], 1)
    })), _vm._v(" "), (_vm.rowExpanded(row._index)) ? _c('tr', [_c('td', {
      class: _vm.prefixCls + '-expanded-cell',
      attrs: {
        "colspan": _vm.columns.length
      }
    }, [_c('Expand', {
      key: row,
      attrs: {
        "row": row,
        "render": _vm.expandRender,
        "index": row._index
      }
    })], 1)]) : _vm._e()]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-783a2256"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/table/table-body.vue
// module id = 652
// module chunks = 1